import {useReducer} from 'react';
import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';
import {ButtonClipboard, Divider, Modal, Transitioner} from 'components';
import {pdfKnowledgeBase} from 'assets';

interface IPageHelpProps {}

const PageHelp = ({}: IPageHelpProps) => {
  useTitle('Help');

  const params = useParams();
  const workspace = params.workspace ?? '';
  const resource = params.resource ?? '';

  const [showModal, toggleModal] = useReducer(s => !s, false);

  return (
    <Transitioner key={`/${workspace}/${resource}`}>
      <div className="flex items-center justify-between">
        <div className="sm:flex-auto">
          <h1 className="font-medium text-lg dark:text-white">Help</h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-darkText">Explore the knowledge base PDF for answers.</p>
          <div className="flex items-center gap-1 text-sm text-gray-700 dark:text-darkText">
            <p>If you have more questions,</p>
            <button type="button" onClick={toggleModal} className="text-primary cursor-pointer underline sm:no-underline hover:underline">
              email us
            </button>
            .
          </div>
        </div>
      </div>
      <Divider />
      <Transitioner delay={0.1} classNames="sm:h-[calc(100svh-175px)]">
        <div className="flex justify-center mb-3 sm:hidden">
          <a href={pdfKnowledgeBase} target="_blank" rel="noopener noreferrer" className="text-sm text-center text-primary max-w-54">
            Don't see the PDF? Click here to open in new tab
          </a>
        </div>
        <iframe src={`${pdfKnowledgeBase}#zoom=110`} className="h-full w-full rounded-md select-none" />
      </Transitioner>

      <Modal visible={showModal} onClose={toggleModal}>
        <h2 className="text-2xl dark:text-white mb-5">Contact us</h2>
        <div className="flex items-center gap-x-3 text-primary">
          <p className="text-slate-800 dark:text-darkText">Email:</p>
          <a href="mailto:admin@das-ar.com" className="font-semibold underline sm:no-underline hover:underline">
            admin@das-ar.com
          </a>
          <ButtonClipboard text="admin@das-ar.com" />
        </div>
      </Modal>
    </Transitioner>
  );
};

export default PageHelp;
